<script setup lang="ts">
import BaseOverlay from '@/overlays/BaseOverlay.vue';
import PicturesGrid from '@/views/shared/PicturesGrid.vue';
import { computed, ref } from 'vue';
import PicturesOverlay from '@/overlays/PicturesOverlay.vue';
import { IGallery, IImage } from '@/interfaces';

const emit = defineEmits(['close']);

interface Props {
  galleries: IGallery[];
  isPersonalMedia?: boolean;
}

const props = withDefaults(defineProps<Props>(), {});

const showPicturesOverlay = ref<boolean>(false);
const pictures = ref<IImage[]>();
const selectedGallery = ref<IGallery | null>(null);

const coverImages = computed(() => {
  return props.galleries
    .map((gallery: IGallery) => gallery.coverImage.source)
    .flat();
});

const gallerySelected = (index: number) => {
  selectedGallery.value = props.galleries[index];
  pictures.value = selectedGallery?.value?.pictures;
  showPicturesOverlay.value = true;
};
</script>

<template>
  <BaseOverlay
    @close="emit('close')"
    :title="isPersonalMedia ? $t('media.myGalleries') : $t('global.galleries')"
  >
    <template #content>
      <PicturesGrid
        :pictures="coverImages"
        @picture-selected="gallerySelected"
      />
    </template>
  </BaseOverlay>

  <PicturesOverlay
    v-if="showPicturesOverlay"
    :pictures="pictures || []"
    :title="selectedGallery?.title"
    @close="showPicturesOverlay = false"
  />
</template>
